import React from "react"
import { connect } from "react-redux"
import { fontWeight, fontSize } from "buoy-theme"
import styled from "styled-components"
import {
  getChatIcon,
  Container,
  Bubble,
} from "../../interview/components/ChatBubble"
import Link from "../../common/components/Link"

const Bold = styled.strong`
  ${fontSize("bodyMain")};
  font-weight: ${fontWeight.regular};
`

const DxocCloseMessage = props => {
  return (
    <Container question id={`chat-bubble-${props.item.index}`}>
      <Bubble isLast={props.isLast} margin="0">
        {getChatIcon(props)}
        <Bold>
          {`Good to know. Based on current CDC guidelines and the symptoms you’ve
          described today, the likelihood of a serious coronavirus infection
          needing immediate medical care is low.`}
          {props.item.link && (
            <React.Fragment>
              <br />
              <br />
              {`Read more about `}
              <Link
                href={props.item.link}
                size="bodyMain"
                target="_blank"
                rel="noopener noreferrer"
              >
                {`coronavirus prevention & treatment here.`}
              </Link>
            </React.Fragment>
          )}
          <br />
          <br />
        </Bold>
      </Bubble>
    </Container>
  )
}

const mapStateToProps = state => ({
  pov: state.identifiers.pov,
  sex: state.identifiers.sex,
})

const DxocCloseMessageWrapper = connect(mapStateToProps)(DxocCloseMessage)

export { DxocCloseMessageWrapper as default, DxocCloseMessage }



// WEBPACK FOOTER //
// ./assets/interview/components/DxocCloseMessage.js